import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import DataService from "../../../services/data.service";
import { ProjectPopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ProjectAttachmentCreateModel {
    projectId: number
    attachmentTypeId: number
    attachmentName?: string
    fileName?: string
    fileResult?: FileCreateResultModel
}

const AddProjectAttachmentPopup: React.FC<ProjectPopupProps> = ({ show, onHide, projectId, projectTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const [file, setFile] = useState<File>();
    const { handleResult, handleException } = useNotifications();
    const { translate } = useTranslations();

    const [formData, setFormData] = useState<ProjectAttachmentCreateModel>({
        projectId: projectId,
        attachmentTypeId: 0,
    });

    const attachmentTypes = useSelectListOptions('api/v1/selectlist/AttachmentTypesForProjectType?projectTypeId=' + projectTypeId, '-- Select attachment type');

    function submit() {
        if (formData && file) {
            DataService
                .createFile(file)
                .then(fileResponse => {
                    handleResult(fileResponse);
                    if (fileResponse.isSuccesful === true && fileResponse.data) {
                        formData.fileResult = fileResponse.data;
                        DataService
                            .create<ProjectAttachmentCreateModel>(`api/v1/ProjectAttachments`, formData)
                            .then(response => {
                                handleResult(response);
                                setServerErrors(response);
                                if (response.isSuccesful === true) {
                                    if (onHide)
                                        onHide();
                                }
                            })
                            .catch(e => handleException(e));
                    }
                    else {
                        handleResult(fileResponse);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string | File): void {
        if (name === 'fileName' && typeof (value) === 'object') {
            setFile(value);
            formData.fileName = value.name;
            formData.attachmentName = value.name;
        }
        else {
            formData[name] = value;
        }
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'attachmentName', label: 'Name', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'attachmentTypeId', label: 'Type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'fileName', label: 'File', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add attachment'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('attachmentTypeId')} options={attachmentTypes} />
                <FileUploadField {...getFieldProps('fileName')} />
                <TextboxField {...getFieldProps('attachmentName')} disabled />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddProjectAttachmentPopup;